"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = require("styled-components");

var _utils = require("../../utils");

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _container = _interopRequireDefault(require("../../legacy/container"));

var _components = require("../../components");

var _wrappers = require("./wrappers");

var _map = _interopRequireDefault(require("./map"));

var _excluded = ["position"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var wrapperPropTypes = {
  /** Children, a node or can be a React component */
  children: _propTypes.node,

  /** position in wrapper */
  position: _propTypes.string
};

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
      position = _ref.position;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, position ? /*#__PURE__*/_react["default"].createElement(_wrappers.HtmlWrapper, {
    position: position
  }, children) : children);
};

Wrapper.propTypes = wrapperPropTypes;
var propTypes = {
  /** Background color */
  backgroundColor: _propTypes.string,

  /** Background Image path */
  backgroundImage: _propTypes.string,

  /** setting for bottom padding amount */
  bottomUnitPadding: _propTypes.number,

  /** container class name */
  className: _propTypes.string,

  /** color from the color scheme */
  colorScheme: _propTypes.string,

  /** open html content object */
  content: (0, _propTypes.arrayOf)(_propTypes.object),

  /** content node or react component */
  contentAbove: _propTypes.node,

  /** content node or react component */
  contentBelow: _propTypes.node,

  /** Custom background for container component */
  customBackground: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string, _propTypes.object]),

  /** cypress test id */
  "data-test-id": _propTypes.string,

  /** html id for container component */
  htmlId: _propTypes.string,

  /** html text color string */
  htmlTextColor: _propTypes.string,

  /** boolean to include styles  */
  includeStyles: _propTypes.bool,

  /** theme object */
  theme: _utils.themePropType,

  /** setting for top padding amount */
  topUnitPadding: _propTypes.number
};
var defaultProps = {
  backgroundColor: "background",
  bottomUnitPadding: 0,
  topUnitPadding: 0
};

var OpenHtml = function OpenHtml(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
      backgroundImage = _ref2.backgroundImage,
      bottomUnitPadding = _ref2.bottomUnitPadding,
      colorScheme = _ref2.colorScheme,
      content = _ref2.content,
      contentAbove = _ref2.contentAbove,
      contentBelow = _ref2.contentBelow,
      className = _ref2.className,
      customBackground = _ref2.customBackground,
      dataTestId = _ref2["data-test-id"],
      htmlTextColor = _ref2.htmlTextColor,
      htmlId = _ref2.htmlId,
      includeStyles = _ref2.includeStyles,
      theme = _ref2.theme,
      topUnitPadding = _ref2.topUnitPadding;
  return /*#__PURE__*/_react["default"].createElement(_components.Background, {
    backgroundColor: backgroundColor,
    backgroundImage: backgroundImage,
    className: className,
    "data-test-id": dataTestId,
    id: htmlId,
    tag: customBackground
  }, /*#__PURE__*/_react["default"].createElement(_container["default"], {
    alignItems: "flex-start",
    flexDirection: "column",
    justifyContent: "flex-start",
    maxWidth: 1440,
    pl: [0, 0, 7],
    px: 0,
    tag: customBackground
  }, /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Container, {
    display: "block",
    pb: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return bottomUnitPadding * padding;
    }),
    pt: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return topUnitPadding * padding;
    })
  }, contentAbove, content && (0, _utils.mapIndexed)(function (_ref3, index) {
    var position = _ref3.position,
        obj = _objectWithoutPropertiesLoose(_ref3, _excluded);

    return /*#__PURE__*/_react["default"].createElement(Wrapper, {
      key: index,
      position: position
    }, (0, _map["default"])(Object.assign({}, obj, {
      className: className,
      colorScheme: colorScheme,
      htmlTextColor: htmlTextColor,
      includeStyles: includeStyles,
      position: position,
      theme: theme
    }), index));
  }, content), contentBelow)));
};

OpenHtml.defaultProps = defaultProps;
OpenHtml.propTypes = propTypes;
OpenHtml.displayName = "Modules.OpenHtml";

var _default = (0, _styledComponents.withTheme)(OpenHtml);

exports["default"] = _default;